package br.com.htms.inspeccaocampo.shared.ui.components

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.RadioButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.semantics.Role
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import br.com.htms.inspeccaocampo.data.FotoAnexo
import br.com.htms.inspeccaocampo.data.ItemVerificacao
import br.com.htms.inspeccaocampo.data.RespostaTernaria

@Composable
fun ItemVerificacaoCard(
    item: ItemVerificacao,
    erro: String?,
    onResposta: (RespostaTernaria) -> Unit,
    onJustificativa: (String) -> Unit,
    onTirarFoto: () -> Unit,
    onAdicionarMaisFoto: () -> Unit,
    onRemoverFoto: (FotoAnexo) -> Unit,
    modifier: Modifier = Modifier
) {
    var mostrarLista by remember { mutableStateOf(false) }

    Card(
        modifier = modifier.fillMaxWidth(),
        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface)
    ) {
        Column(Modifier.padding(12.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
            Text(item.titulo, fontWeight = FontWeight.SemiBold)
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceEvenly,
                verticalAlignment = Alignment.CenterVertically
            ) {
                RespostaTernaria.entries.forEach { opcao ->
                    RowOption(
                        label = opcao.rotulo,
                        selected = item.resposta == opcao,
                        onClick = { onResposta(opcao) }
                    )
                }
            }
            when (item.resposta) {
                RespostaTernaria.SIM -> {
                    CampoFotoRow(
                        label = "Tirar foto",
                        obrigatorio = item.fotoObrigatoriaSeSim,
                        quantidadeFotos = item.fotos.size,
                        onTirarFoto = onTirarFoto,
                        onAdicionarMais = onAdicionarMaisFoto,
                        onAbrirLista = { mostrarLista = true }
                    )
                }
                RespostaTernaria.NAO -> {
                    OutlinedTextField(
                        value = item.justificativa,
                        onValueChange = onJustificativa,
                        label = { Text("Justificativa *") },
                        modifier = Modifier.fillMaxWidth(),
                        minLines = 2,
                        colors = FormFieldDefaults.textFieldColors(),
                        isError = erro != null
                    )
                    CampoFotoRow(
                        label = "Tirar foto",
                        obrigatorio = item.fotoObrigatoriaSeNao,
                        quantidadeFotos = item.fotos.size,
                        onTirarFoto = onTirarFoto,
                        onAdicionarMais = onAdicionarMaisFoto,
                        onAbrirLista = { mostrarLista = true }
                    )
                }
                RespostaTernaria.NA -> {
                    OutlinedTextField(
                        value = item.justificativa,
                        onValueChange = onJustificativa,
                        label = { Text("Justificativa *") },
                        modifier = Modifier.fillMaxWidth(),
                        minLines = 2,
                        colors = FormFieldDefaults.textFieldColors(),
                        isError = erro != null
                    )
                }
                null -> Unit
            }
            erro?.let {
                Text(it, color = MaterialTheme.colorScheme.error, style = MaterialTheme.typography.bodySmall)
            }
        }
    }

    if (mostrarLista) {
        val ultimaFoto = item.fotos.lastOrNull()
        CenteredAppDialog(
            onDismissRequest = { mostrarLista = false },
            title = item.titulo,
            text = if (item.fotos.isEmpty()) {
                "Nenhuma foto."
            } else {
                "${item.fotos.size} foto(s). Remover a última?"
            },
            confirmLabel = if (ultimaFoto != null) "Remover última" else null,
            onConfirm = if (ultimaFoto != null) {
                {
                    onRemoverFoto(ultimaFoto)
                    if (item.fotos.size <= 1) mostrarLista = false
                }
            } else {
                null
            },
            dismissLabel = "Fechar"
        )
    }
}

@Composable
private fun RowOption(label: String, selected: Boolean, onClick: () -> Unit) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
        modifier = Modifier
            .clickable(role = Role.RadioButton, onClick = onClick)
            .padding(horizontal = 4.dp, vertical = 2.dp)
    ) {
        RadioButton(selected = selected, onClick = null)
        Text(label, fontWeight = FontWeight.Medium)
    }
}
